<template>
    <main class="tw-relative">
        <div class="hero tw-px-3 tw-pb-3 md:tw-px-12 md:tw-pb-12">
            <div class="tw-text-center lg:tw-text-left">
                <h1 class="tw-pt-10 lg:tw-pt-5">Encontre<br class="tw-hidden lg:tw-block"> o curso <br
                    class="lg:tw-hidden">ideal<br class="tw-hidden lg:tw-block"> para si</h1>
                <p class="tw-pt-1">Adquira novos conhecimentos, melhore as suas competências ou aprenda uma nova profissão.</p>
            </div>
<!--            <div class="input-group input-group-courses tw-mt-5 lg:tw-mt-6">-->
<!--                <select-->
<!--                    class="form-control custom-select"-->
<!--                    style="border-radius: 6px;"-->
<!--                    v-if="$store.state.courseList !== []"-->
<!--                    v-model="selectedCourse"-->
<!--                    @change="redirectToCourse"-->
<!--                >-->
<!--                    <option value="">Selecione um curso</option>-->
<!--                    <option v-for="course in $store.state.courseList" :key="course.code" :value="slugifyCourse(course.humanFriendlyName)">{{ course.humanFriendlyName }}</option>-->
<!--                </select>-->
<!--            </div>-->
          <button class="btn-nav tw-mt-6 tw-mx-auto lg:tw-mx-0" @click.prevent="scrollTo('header')">
            Escolher um curso
          </button>
          <ul v-if="$store.state.coursesList" class="tw-shadow">
            <li class="tw-pointer-events-none"><b>Selecione um curso:</b></li>
            <li v-for="course in $store.state.courseList" :key="course.code" v-html="course.humanFriendlyName" @click.prevent="redirectToCourse(slugifyCourse(course.humanFriendlyName))" />
          </ul>
        </div>
        <section class="courses tw-container tw-pt-10 tw-pb-12 lg:tw-pt-16 lg:tw-pb-20">
          <div class="tw-text-center">
            <small class="tw-pt-6 lg:tw-pt-16 tw-pb-5 tw-block tw-mx-auto tw-font-bold tw-uppercase">Cursos e saídas profissionais</small>
            <h2>Venha conhecer <br class="lg:tw-hidden">os nossos cursos</h2>
            <div class="tw-grid tw-grid-cols-2 tw-gap-10 tw-pt-8 lg:tw-grid-cols-5 lg:tw-pt-16">
              <div class="course">
                <img src="~@/assets/img/1.png">
                <p class="tw-pt-3">Agricultura<br> e Espaços Verdes</p>
              </div>
              <div class="course">
                <img src="~@/assets/img/2.png">
                <p class="tw-pt-3">Comunicação<br> Relações Públicas</p>
              </div>
              <div class="course">
                <img src="~@/assets/img/3.png">
                <p class="tw-pt-3">Cuidados<br> Animais</p>
              </div>
              <div class="course">
                <img src="~@/assets/img/4.png">
                <p class="tw-pt-3">Cuidados<br> de Saúde</p>
              </div>
              <div class="course">
                <img src="~@/assets/img/5.png">
                <p class="tw-pt-6">Decoração</p>
              </div>
              <div class="course">
                <img src="~@/assets/img/6.png">
                <p class="tw-pt-3">Informática<br> e Programação</p>
              </div>
              <div class="course">
                <img src="~@/assets/img/7.png">
                <p class="tw-pt-3">Marketing, Design<br> e Multimédia</p>
              </div>
              <div class="course">
                <img src="~@/assets/img/8.png">
                <p class="tw-pt-6">Turismo</p>
              </div>
              <div class="course">
                <img src="~@/assets/img/9.png">
                <p class="tw-pt-3">Serviços <br> Administrativos</p>
              </div>
              <div class="course">
                <img src="~@/assets/img/10.png">
                <p class="tw-pt-6">Videojogos</p>
              </div>
            </div>
          </div>
          <div class="tw-flex tw-items-center tw-justify-center tw-my-8 lg:tw-my-16">
            <button
                type="button"
                class="btn-nav"
                @click.prevent="scrollTo('header')"
            >
              Encontre o curso ideal para si
            </button>
          </div>
        </section>
    </main>
</template>

<script>
export default {
    data() {
        return {
            courseList: [],
            selectedCourse: '',
            // coursesList: false,
        };
    },
    methods: {
        scrollTo(target) {
          document.querySelector(`${target}`).scrollIntoView({
            behavior: 'smooth',
          });
          this.$store.state.coursesList = true;
        },
        slugifyCourse(course) {
            return slugify(course);
        },
        redirectToCourse(course) {
            this.selectedCourse = course;
            this.$router.push({ path: `/${(course).toLowerCase()}`, query: this.$route.query });
        },
    },
    created() {
        axios
            .get('https://kw-lp-info.s3-eu-west-1.amazonaws.com/master-d/course-list.json')
            .then((response) => {
                this.courseList = response.data;
            })
            .catch((error) => {
                console.log(error);
            });
    },
    name: 'Home',
};
</script>
<style lang="scss">
@import '@/assets/scss/home.scss';

section {

  &.courses {

    small {
      @apply tw-text-center;
      color: #FF5039;
    }

    h2 {
      color: #1E1E1E;
      font-weight: 700;
      font-size: 24px;
      line-height: 26px;
      @screen lg {
        font-size: 40px;
        line-height: 50px;
      }
    }

    .course {
      @apply tw-pb-4 tw-mt-6 tw-flex tw-flex-col tw-items-center tw-justify-start;
      box-shadow: 0px 4px 25px 0px rgba(#225666, 0.07);
      width: fit-content;

      @screen lg {
        @apply tw-mt-6 tw-pb-4;
      }
    }

    img {
      display: block;
      margin: 0 auto;
      width: auto;
      height: auto;
    }

    p {
      color: $main_color;
      font-weight: 700;
      font-size: 16px;
      line-height: 22px;

    }
  }
}
</style>
